import React from 'react';
import { FileTextIcon, RefreshCwIcon, ClipboardListIcon, ReceiptIcon, MinusCircleIcon, FileIcon, UsersIcon } from 'lucide-react';
interface SidebarProps {
  activeDocument: string;
  onDocumentChange: (docType: string) => void;
}
const documentTypes = [{
  id: 'invoice-3',
  label: 'Invoice v3 (Alt Layout)',
  available: true
}, {
  id: 'invoice-3-void',
  label: 'Invoice v3 (VOID)',
  available: true
}, {
  id: 'exchange-order',
  label: 'Exchange Order',
  available: true
}, {
  id: 'quotation',
  label: 'Quotation',
  available: true
}, {
  id: 'receipt',
  label: 'Receipt',
  available: true
}, {
  id: 'receipt-2',
  label: 'Receipt v2 (B2B)',
  available: true
}, {
  id: 'credit-note',
  label: 'Credit Note',
  available: true
}, {
  id: 'bill',
  label: 'Bill',
  available: true
}, {
  id: 'pax-statement',
  label: 'Pax Statement',
  available: true
}, {
  id: 'pax-statement-2',
  label: 'Pax Statement 2 (A4)',
  available: true
}];
export function Sidebar({
  activeDocument,
  onDocumentChange
}: SidebarProps) {
  const documents = [{
    id: 'invoice-3',
    label: 'Invoice v3 (Alt Layout)',
    icon: FileTextIcon,
    available: true
  }, {
    id: 'invoice-3-void',
    label: 'Invoice v3 (VOID)',
    icon: FileTextIcon,
    available: true
  }, {
    id: 'exchange-order',
    label: 'Exchange Order',
    icon: RefreshCwIcon,
    available: true
  }, {
    id: 'quotation',
    label: 'Quotation',
    icon: ClipboardListIcon,
    available: true
  }, {
    id: 'receipt',
    label: 'Receipt',
    icon: ReceiptIcon,
    available: true
  }, {
    id: 'receipt-2',
    label: 'Receipt v2 (B2B)',
    icon: ReceiptIcon,
    available: true
  }, {
    id: 'credit-note',
    label: 'Credit Note',
    icon: MinusCircleIcon,
    available: true
  }, {
    id: 'bill',
    label: 'Bill',
    icon: FileIcon,
    available: true
  }, {
    id: 'pax-statement',
    label: 'Pax Statement',
    icon: UsersIcon,
    available: true
  }, {
    id: 'pax-statement-2',
    label: 'Pax Statement 2 (A4)',
    icon: UsersIcon,
    available: true
  }];
  return <div className="w-64 bg-white border-r border-neutral-200 h-screen flex flex-col" data-id="element-1214">
      {/* Header */}
      <div className="p-6 border-b border-neutral-200" data-id="element-1215">
        <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-3 flex items-center justify-center shadow-sm" data-id="element-1216">
          <span className="text-white font-bold text-sm" data-id="element-1217">MT</span>
        </div>
        <h2 className="text-sm font-bold text-neutral-900 uppercase tracking-wider" data-id="element-1218">
          Document Templates
        </h2>
      </div>

      {/* Navigation Items */}
      <nav className="flex-1 p-4 overflow-y-auto" data-id="element-1219">
        <ul className="space-y-1" data-id="element-1220">
          {documents.map(doc => <li key={doc.id} data-id="element-1221">
              <button onClick={() => doc.available && onDocumentChange(doc.id)} disabled={!doc.available} className={`
                  w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium transition-all
                  ${activeDocument === doc.id ? 'bg-blue-50 text-blue-700 shadow-sm' : doc.available ? 'text-neutral-700 hover:bg-neutral-50' : 'text-neutral-400 cursor-not-allowed'}
                `} data-id="element-1222">
                <div className="flex items-center justify-between" data-id="element-1223">
                  <span data-id="element-1224">{doc.label}</span>
                  {!doc.available && <span className="text-xs text-neutral-400 italic" data-id="element-1225">
                      Soon
                    </span>}
                </div>
              </button>
            </li>)}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-neutral-200" data-id="element-1226">
        <p className="text-xs text-neutral-500 leading-relaxed" data-id="element-1227">
          Standardized document templates for travel management
        </p>
      </div>
    </div>;
}